module.exports = __webpack_public_path__ + "static/media/fondo-finca-mobile.c62e6f16.jpg";